import { render, staticRenderFns } from "./HealthDetailsWidget.vue?vue&type=template&id=369533f2&scoped=true"
import script from "./HealthDetailsWidget.vue?vue&type=script&lang=js"
export * from "./HealthDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369533f2",
  null
  
)

/* custom blocks */
import block0 from "./HealthDetailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports